import { createSelector } from 'reselect'
// @ts-ignore
import qs from 'qs'
import { Map } from 'immutable'
// @ts-ignore
import { parseQuery } from 'helpers/urlHelper'
import { START_PATH } from 'app/constants/navLinks'

export const getRouter = (state: any) => state.get('router')

export const getRouterLocation = createSelector(getRouter, router => router.get('location'))

export const pathname = createSelector(getRouterLocation, location => location.get('pathname'))

export const search = createSelector(getRouterLocation, location => location.get('search'))

export const locationState = createSelector(getRouterLocation, location => location.get('state'))

export const isRedirectPage = createSelector(locationState, state => state && state.get('externalRedirect') === true)

export const getRedirectQuery = createSelector(locationState, state => state && state.get('redirectQuery'))

export const getUrlPartByIndex = createSelector(pathname, path => (index: any) => path.split('/')[index])

export const organizationId = createSelector(getUrlPartByIndex, getUrlPartByIndex => parseInt(getUrlPartByIndex(3)))

export const queryParams = createSelector(search, search => qs.parse(search, { ignoreQueryPrefix: true }))

export const getParam = createSelector(queryParams, params => (param: any) => params[param])

/**
 * @return Map({
 *   token,
 *   uid,
 *   action,
 *   invitation,
 *   completePreviousActivity,
 *   autoPlay,
 * }) or false
 */

export const getInfoFromHash = createSelector(getParam, getParam => {
  const hash = getParam('hash')
  return hash && parseQuery(window.atob(hash as any))
})

export const userInfoFromHash = createSelector(getInfoFromHash, parsedParams => {
  return parsedParams && parsedParams.uid && parsedParams.token && Map(parsedParams)
})

export const isLoginByMagicLink = createSelector(
  [pathname, getParam],
  (path, getParam) => path === '/launch' && !!getParam('hash')
)

export const secondRoutePieceAsInt = createSelector(getUrlPartByIndex, getUrlPartByIndex =>
  parseInt(getUrlPartByIndex(2))
)

export const getPathnameWithoutLastPart = createSelector(pathname, pathname => {
  const path = pathname.match(/^.+\//g)
  return pathname !== '/' ? path && path[0].slice(0, -1) : pathname
})

export const isStartPage = createSelector(pathname, (pathname: string) => {
  return pathname.includes(START_PATH)
})
